;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Stack from "@mui/material/Stack"
import type { ReactNode } from "react"

type StackSpacedProps = {
  children: ReactNode
  spacing?: number
}

export default function StackSpaced({ children, spacing = 2 }: StackSpacedProps) {
  return (
    <div className={"max-w-[480px] w-full"}>
      <Stack
        spacing={spacing}
        direction="column"
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {children}
      </Stack>
    </div>
  )
}
